/* Fill-up animation for code-drawn taste triangles (.pw-tt). Adds .pw-tt-in when scrolled into view. */
(function () {
  "use strict";
  function init() {
    var els = document.querySelectorAll(".pw-tt:not([data-tt])");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.setAttribute("data-tt", "1"); el.classList.add("pw-tt-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("pw-tt-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.35 });
    els.forEach(function (el) { el.setAttribute("data-tt", "1"); io.observe(el); });
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
